"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getIntermediateReadingDataAction = getIntermediateReadingDataAction;
exports.setApiError = setApiError;
exports.setCurrentStep = setCurrentStep;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _intermediateReadingApi = require("./intermediateReadingApi");
var _MeterReadingPage = require("../../../cic/pages/MeterReadingPage/MeterReadingPage");
var _intermediateReadingFunctions = require("./intermediateReadingFunctions");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var IntermediateReadingActionTypes = /*#__PURE__*/function (IntermediateReadingActionTypes) {
  IntermediateReadingActionTypes["SET_INTERMEDIATE_READING_DATA"] = "SET_INTERMEDIATE_READING_DATA";
  IntermediateReadingActionTypes["SET_LOADING"] = "SET_LOADING";
  IntermediateReadingActionTypes["SET_ERROR"] = "SET_ERROR";
  IntermediateReadingActionTypes["SET_CURRENT_STEP"] = "SET_CURRENT_STEP";
  return IntermediateReadingActionTypes;
}(IntermediateReadingActionTypes || {});
var initialState = {
  intermediateReadingData: undefined,
  currentStep: _MeterReadingPage.MeterReadingWizardStepEnum.READING,
  loading: true,
  apiError: false,
  errorStatus: '',
  errorCode: ''
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case IntermediateReadingActionTypes.SET_INTERMEDIATE_READING_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        intermediateReadingData: action.intermediateReadingData,
        loading: false
      });
    case IntermediateReadingActionTypes.SET_LOADING:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: true
      });
    case IntermediateReadingActionTypes.SET_ERROR:
      return _objectSpread(_objectSpread({}, state), {}, {
        loading: false,
        apiError: true,
        errorStatus: action.errorStatus,
        errorCode: action.errorCode
      });
    case IntermediateReadingActionTypes.SET_CURRENT_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        currentStep: action.currentStep
      });
    default:
      return state;
  }
}
function setCurrentStep(dispatch, currentStep) {
  dispatch({
    type: IntermediateReadingActionTypes.SET_CURRENT_STEP,
    currentStep: currentStep
  });
}
function setApiError(dispatch, errorStatus, errorCode) {
  dispatch({
    type: IntermediateReadingActionTypes.SET_ERROR,
    errorStatus: errorStatus,
    errorCode: errorCode
  });
}
function getIntermediateReadingDataAction(dispatch) {
  dispatch({
    type: IntermediateReadingActionTypes.SET_LOADING
  });
  (0, _intermediateReadingApi.getIntermediateReadingMeters)().then(function (response) {
    dispatch({
      type: IntermediateReadingActionTypes.SET_INTERMEDIATE_READING_DATA,
      intermediateReadingData: (0, _intermediateReadingFunctions.getMeterFromSessionStorage)(response.data.content)
    });
  }).catch(function (error) {
    var _error$response;
    var status = (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status;
    if (status === 500) {
      dispatch({
        type: IntermediateReadingActionTypes.SET_ERROR,
        errorStatus: '500',
        errorCode: 'serverError'
      });
    }
  });
}
var _default = exports.default = reducer;